import React, { FC, useEffect } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import Questionnaire from '~/components/views/Questionnaire';
import { useRefScrollTo } from '~/hooks/useRefScrollTo';
import { useSaveDraft } from '~/controllers/draft';

const QuestionnairePage: FC = () => {
  const ref = useRefScrollTo();
  const { t } = useTranslation('fillApplication');
  // const draftMutation = useSaveDraft();

  // useEffect(() => {
  //   draftMutation.mutate({ stepData: null });
  // }, []);

  return (
    <div ref={ref}>
      <Typography.Title>{t('Additional Information')}</Typography.Title>
      <Typography.Paragraph>{t('Please share additional information about your business.')}</Typography.Paragraph>

      <Questionnaire />
    </div>
  );
};

export default QuestionnairePage;
